<script lang="ts">
    import type { JobServiceAttributesType } from "./types";
    import IconJobPhoto from '../../shared/Icons/IconJobPhoto.svelte';
    import IconJobNote from '../../shared/Icons/IconJobNote.svelte';
    import IconJobLoaded from '../../shared/Icons/IconJobLoaded.svelte';

    export let serviceAttributes: JobServiceAttributesType|null;
    export let jobType: string|null = null;
    export let scale: number = 0.7;
</script>

<div style="margin-top: 1px; display: {serviceAttributes?.load ? 'block': 'none'}">
    <IconJobLoaded loaded={serviceAttributes?.load} scale={scale}/>
</div>
<div style="visibility: {serviceAttributes?.photo ? 'visible': 'hidden'}">
    <IconJobPhoto photos={serviceAttributes?.photo || []} scale={scale}/>
</div>
<div style="visibility: {serviceAttributes?.note || serviceAttributes?.tags?.length || Object.keys(serviceAttributes?.extra || {}).filter(e => !['total_weight', 'parcels', 'non_normative_size'].includes(e)).length ? 'visible': 'hidden'}">
    <IconJobNote note={serviceAttributes?.note || ''} tags={serviceAttributes?.tags || []} extra={serviceAttributes?.extra} {jobType} scale={scale}/>
</div>